import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/exchanges/ExchangesClient.tsx");
